import { useEffect } from "react";

export default function DevToolsProtector() {
    useEffect(() => {
        if (process.env.REACT_APP_PRODUCTION_MODE !== 'development') {
            // 1. Disable Right-Click
            const disableContextMenu = (e) => e.preventDefault();
            document.addEventListener("contextmenu", disableContextMenu);

            // 2. Block Common DevTools Shortcuts
            const blockKeys = (e) => {
                if (
                    (e.ctrlKey && e.shiftKey && ["I", "J", "C"].includes(e.key)) || // Ctrl+Shift+I/J/C
                    (e.ctrlKey && e.key === "u") || // Ctrl+U
                    (e.key === "F12") // F12
                ) {
                    e.preventDefault();
                    redirectUser();
                }
            };
            document.addEventListener("keydown", blockKeys);

            // 3. Detect DevTools

            const detectDevTools = () => {
                // Method A: Size check
                if (window.outerWidth - window.innerWidth > 160 || window.outerHeight - window.innerHeight > 160) {
                    redirectUser();
                }

                // Method B: Console trick
                let element = new Image();
                Object.defineProperty(element, "id", {
                    get: function () {
                        redirectUser();
                        return '';  // fix: ensures getter returns a value
                    },
                });

                // Method C: Debugger lag
                let start = performance.now();
                debugger;
                if (performance.now() - start > 100) {
                    redirectUser();
                }
            };

            const interval = setInterval(detectDevTools, 2000);

            // Cleanup
            return () => {
                document.removeEventListener("contextmenu", disableContextMenu);
                document.removeEventListener("keydown", blockKeys);
                clearInterval(interval);
            };
        }
    }, []);

    // 4. Redirect Function
    const redirectUser = () => {
        window.location.href = "/warning";
        // 👉 Replace with your custom page
        // e.g., "/logout" or "https://yoursite.com/warning"
    };

    return null; // no UI
}